/* tslint:disable:jsx-no-lambda WI:47697 */
import { observer } from 'mobx-react-lite';
import { lightable, lighted, LightningProps } from 'owa-lightning-v2';
import { OptInFirstRunExperience } from 'owa-mail-fre-view';
import { getRTL } from '@fluentui/react/lib/Utilities';
import * as React from 'react';

export default lightable(
    observer(function OptInFirstRunLightningModal(props: LightningProps) {
        return (
            <OptInFirstRunExperience
                onClose={() => lighted(props.lid)}
                hasStaticArtwork={getRTL()}
            />
        );
    })
);
